// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAQ7FyeuIIcN2IwAi4CjMUzWzWX4WRSbvg",
    authDomain: "repairbook-d1c03.firebaseapp.com",
    projectId: "repairbook-d1c03",
    storageBucket: "repairbook-d1c03.firebasestorage.app",
    messagingSenderId: "580453979820",
    appId: "1:580453979820:web:426f33b2dc6cf818543109",
    measurementId: "G-CS2PC2QSFH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, analytics, db, auth }; 